import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, ReceiptText } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const RefundRequestCard = () => {
  const [s, setS] = useState(null);
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/payments/refund-request").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s?.payment || (!s.eligible && !s.requested)) return null;
  const p = s.payment;

  const send = async () => {
    setBusy(true);
    try {
      toast.success((await api.post("/payments/refund-request", { reason })).data.message);
      setS((x) => ({ ...x, eligible: false, requested: true })); setOpen(false);
    } catch (e) { toast.error(errMsg(e, "Could not send your request")); } finally { setBusy(false); }
  };

  return (
    <div className="mm-card p-4 flex items-center gap-3" data-testid="refund-request-card">
      <ReceiptText size={20} className="text-mm-primary shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-sm">Your purchase · {p.receipt_id}</div>
        <div className="text-xs text-mm-muted">${p.amount.toFixed(2)} by {p.method} on {new Date(p.date).toLocaleDateString()}{s.eligible ? ` · ${s.days_left} day${s.days_left === 1 ? "" : "s"} left to request a refund` : ""}</div>
      </div>
      {s.requested ? <span className="mm-chip !cursor-default !text-xs shrink-0" data-testid="refund-requested">Refund requested</span> : (
        <button className="mm-btn-ghost !py-2 !px-3 text-sm shrink-0" onClick={() => setOpen(true)} data-testid="refund-request-open">Request a refund</button>
      )}
      <Dialog open={open} onOpenChange={(o) => !busy && setOpen(o)}>
        <DialogContent className="max-w-md" data-testid="refund-request-dialog">
          <DialogHeader>
            <DialogTitle>Request a refund</DialogTitle>
            <DialogDescription>Full refund within 14 days of purchase. We'll email you once it's processed.</DialogDescription>
          </DialogHeader>
          <textarea className="mm-input min-h-[90px]" maxLength={500} placeholder="Anything you'd like to share? (optional)" value={reason}
            onChange={(e) => setReason(e.target.value)} data-testid="refund-request-reason" />
          <div className="flex justify-end gap-2">
            <button className="mm-btn-ghost !py-2 !px-4 text-sm" disabled={busy} onClick={() => setOpen(false)} data-testid="refund-request-cancel">Cancel</button>
            <button className="mm-btn !py-2 !px-4 text-sm inline-flex items-center gap-2" disabled={busy} onClick={send} data-testid="refund-request-submit">
              {busy && <Loader2 size={14} className="animate-spin" />} Send request
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
